module.exports = __webpack_public_path__ + "img/meat_bobotie.567d644f.jpeg";